import 'htmx.org';
import QRCode from 'qrcode';


// TODO: move this
function initShareQrCode() {
    const container = document.getElementById("qr-code");
    if (!container) {
        return;
    }

    const url = container.getAttribute("data-qr-url");
    const canvas = document.getElementById("qr-code-canvas");
    if (!url || !canvas) {
        return;
    }

    QRCode.toCanvas(canvas, url, { width: 200, margin: 1 }, (error) => {
        if (error) {
            console.error("Failed to render QR code", error);
        }
    });

    const downloadBtn = document.getElementById("qr-code-download");
    if (downloadBtn && !downloadBtn.dataset.qrDownloadInitialized) {
        downloadBtn.dataset.qrDownloadInitialized = "true";
        downloadBtn.addEventListener("click", () => {
            const link = document.createElement("a");
            link.href = canvas.toDataURL("image/png");
            link.download = "form-qr.png";
            link.click();
        });
    }
}

document.addEventListener("DOMContentLoaded", initShareQrCode);
document.addEventListener("htmx:afterSwap", initShareQrCode);


(function () {
    try {
        var tz = Intl.DateTimeFormat().resolvedOptions().timeZone; // e.g. "Europe/Paris"
        if (tz) {
            // 1 year, path=/, SameSite=Lax
            document.cookie = "tz=" + encodeURIComponent(tz) +
                "; path=/; max-age=31536000; SameSite=Lax";
        }
    } catch (e) { /* ignore */ }
})();
